import './App.css'
import './index.css'
import ClientDetails from './pages/ClientDetails/ClientDetails'
import { ClientInvestments } from './pages/ClientInvestments/ClientInvestments'
import ClientPdf from './pages/ClientPdf/ClientPdf'
import LoginPage from './pages/Login/LoginPage'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Layout from "./components/Layout/Layout"
import { DownloadPdf } from './pages/DownloadPdf/DownloadPdf'
import PlanOutput from './pages/PlanOutput/PlanOutput'
import Search from './pages/Search/Search'
import Admin from './pages/Admin/Admin'
function App() {
  
  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route element={<Layout/>}>
      <Route path='/client-details' element={<ClientDetails/>}/>
      <Route path='/client-investments' element={<ClientInvestments/>}/>
      <Route path='/search' element={<Search/>}/>
      </Route>
      <Route path='/' element={<LoginPage/>}/>
      <Route path='/login' element={<LoginPage/>}/>
      <Route path='/plan-output' element={<PlanOutput/>}/>
      <Route path='/client-pdf/:plan_id' element={<ClientPdf/>}/>
      <Route path='/download-pdf' element={<DownloadPdf/>}/>
      <Route path='/admin' element={<Admin/>}/>
    </Routes>
    </BrowserRouter>
    
    </>
  )
}

export default App
